import { render, staticRenderFns } from "./TopGeneralInfoItems.vue?vue&type=template&id=51b70d86&scoped=true&slot-scope=props&"
import script from "./TopGeneralInfoItems.vue?vue&type=script&lang=js&"
export * from "./TopGeneralInfoItems.vue?vue&type=script&lang=js&"
import style0 from "./TopGeneralInfoItems.vue?vue&type=style&index=0&id=51b70d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b70d86",
  null
  
)

export default component.exports